import {EventEmitter} from 'events'

class WSocket extends EventEmitter {
  // 初始化 连接
  init (url) {
    this.url = url
    this.socket = new WebSocket(this.url)
    this.socket.onopen = this.onopen.bind(this)
    this.socket.onmessage = this.onmessage.bind(this)
    this.socket.onerror = this.onerror.bind(this)
    this.socket.onclose = this.onclose.bind(this)
    console.log(' init websoicket ')
  }

  /**
   * 重新创建链接
   */
  reInit () {
    if (!this.url) return
    this.init(this.url)
  }

  send (data) {
    if (!this.socket) {
      console.info('this.socket is null ')
      return
    }
    if (WebSocket.OPEN !== this.socket.readyState) {
      if (this.isStop) return
      this.init(this.url)
      return false
    }

    this.socket.send(data)
    return true
  }

  close (code, reason) {
    this.socket.close(code, reason)
  }

  // 默认方法
  onopen (e) {
    console.log('创建成功 ', this.url)
    this.emit('open', '已连接')
  }

  onmessage (e) {
    this.emit('message', e.data)
  }

  onerror (e) {
    this.emit('error', '连接错误')
  }

  onclose (e) {
    this.emit('close', '连接已断开')
  }

  stop () {
    this.isStop = true
  }

  resetStop () {
    this.isStop = false
  }
}

export default WSocket



// WEBPACK FOOTER //
// ./src/libs/websocket/websocket.js